module.exports = __webpack_public_path__ + "static/img/file_json.fa8ad6cf.png";